import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen font-sans text-slate-900 bg-white" data-id="element-220">
      <Header data-id="element-221" />
      <main className="flex-grow pt-20" data-id="element-222">{children}</main>
      <Footer data-id="element-223" />
    </div>;
}